import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkRole',
})
export class CheckRolePipe implements PipeTransform {

  transform(userRoleId: string, roleIdToCheck?: string): boolean {
    if (typeof roleIdToCheck !== 'string') {
      throw new Error('[checkRole - pipe] Cannot use this pipe without a string');
    }
    return userRoleId === roleIdToCheck;
  }

}
